import { cn } from "@/lib/utils";

/**
 * The track of a segmented control. In dark mode it is recessed (the `field`
 * fill with a 9% edge); in light it is the pale `secondary` track it always was.
 * Exported so the Photos date-range chips, which are pressed buttons rather than
 * tabs, can wear the same look. See [[segmented-filter.spec]].
 */
export const SEGMENTED_TRACK =
  "flex gap-1 rounded-[10px] bg-field p-1 dark:ring-1 dark:ring-inset dark:ring-border-strong";

/**
 * One segment of the track: the raised `selected` chip when selected (with a 9%
 * edge instead of a shadow in dark, where a shadow does not show), muted text
 * with a hover wash when not. Callers add layout only.
 */
export function segmentedOptionClass(selected: boolean) {
  return cn(
    "flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md px-2.5 py-2 text-[13px] font-medium",
    // Press: a small squeeze while the button is held, on the selected
    // option too. `motion-safe` leaves it off for reduced-motion users.
    "transition-[color,background-color,box-shadow,scale] duration-150 ease-out motion-safe:active:scale-[0.96]",
    selected
      ? "bg-selected text-foreground shadow-sm dark:shadow-none dark:ring-1 dark:ring-inset dark:ring-border-strong"
      : // Hover: a wash of the text colour, so it lifts the track gently
        // in light and dark alike. Tailwind gates `hover:` to devices that
        // can hover, so a tap never leaves it stuck.
        "text-muted-foreground hover:bg-foreground/[0.06] hover:text-foreground",
  );
}
